import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import routeMeta from '../seo/route-meta';

const { ROUTE_META, DEFAULT_TITLE, DEFAULT_DESCRIPTION } = routeMeta;

const resolveMeta = (pathname) => {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (ROUTE_META[normalized]) return ROUTE_META[normalized];
  if (normalized.startsWith('/blog/')) return ROUTE_META['/blog'];
  if (normalized.startsWith('/references/')) return ROUTE_META['/references'];
  return null;
};

const PageTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = resolveMeta(pathname);
    document.title = meta ? meta.title : DEFAULT_TITLE;

    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute(
        'content',
        meta && meta.description ? meta.description : DEFAULT_DESCRIPTION
      );
    }

    const existingRobotsTag = document.querySelector('meta[name="robots"]');
    if (meta && meta.robots) {
      const robotsTag = existingRobotsTag || document.createElement('meta');
      robotsTag.setAttribute('name', 'robots');
      robotsTag.setAttribute('content', meta.robots);
      if (!existingRobotsTag) document.head.appendChild(robotsTag);
    } else if (existingRobotsTag) {
      existingRobotsTag.remove();
    }
  }, [pathname]);

  return null;
};

export default PageTitle;
